import { BannerType, Button, Icon } from '@symphony-ui/uitoolkit-components';
import DownloadContext from 'contexts/DownloadContext';
import NavigationContext from 'contexts/NavigationContext';
import ApiServerRequest from 'models/ApiServerRequest';
import ApiServerURL from 'models/ApiServerUrl';
import SyndicateContext from '../../context/SyndicateContext';
import * as React from 'react';
import { sendFetchError, sendMessage } from 'utils/messageUtils';
const FindSourceButton = ({ name, removeName, transactionId }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const { updateTab } = React.useContext(NavigationContext);
    const { setUpdateId } = React.useContext(SyndicateContext);
    const [loadingSourceButton, setLoadingSourceButton] = React.useState(false);
    const findSource = React.useCallback(() => {
        if (name !== undefined) {
            setLoadingSourceButton(true);
            const url = new ApiServerURL('/syndicate/transactions/find-with-manager');
            url.searchParams.append('name', name);
            if (transactionId !== undefined) {
                url.searchParams.append('transactionId', transactionId);
            }
            const request = new ApiServerRequest(url);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    if (body !== null) {
                        setUpdateId(body);
                        updateTab('overview', 'UPDATE');
                    }
                    else {
                        sendMessage("'" + name + "' no longer is a name used for a party, so it will be removed", BannerType.INFO);
                        if (removeName !== undefined) {
                            removeName(name);
                        }
                    }
                }
                catch (error) {
                    sendFetchError('Unable to find source', error, request);
                    //
                }
                finally {
                    setLoadingSourceButton(false);
                }
            })();
        }
    }, [name, transactionId, apiFetchJson, setUpdateId, updateTab, removeName]);
    const disabledSourceButton = React.useMemo(() => (name === undefined), [name]);
    return (React.createElement(Button, { disabled: disabledSourceButton, iconButton: true, loading: loadingSourceButton, onClick: findSource, size: 'small' },
        React.createElement(Icon, { iconName: 'search' })));
};
export default FindSourceButton;
